var map = {
	"./discover-g.png": "U1yX",
	"./discover.png": "LGRo"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "VcwH";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pay ^\.\/discover.*\.png$
// module id = VcwH
// module chunks = 1